module.exports = __webpack_public_path__ + "static/media/luggage.2ea80655.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/amenities/luggage.svg
// module id = 567
// module chunks = 0